export interface ColumnField {
    field: string;
    displayName: string;
    fieldType?: FieldType;
    columnType?: ColumnType;
    width?: number;
    actions?: PaginatedDataActions[];
    actionsConfig?: ActionConfig;
    buttonClick?: (cell: any) => void;
}

export enum FieldType {
    String = 'string',
    CheckBox = 'checkbox',
    BooleanToString = 'booleanToString',
    StringToDate = 'stringToDate',
    StringToDateTime = 'stringToDateTime',
    StringToDecimal = 'stringToDecimal',
    ListLength = 'listLength',
    Action = 'action',
    Button = 'button'
}

export enum ColumnType {
    ExtraSmall = 'extra-small',
    Small = 'small-column',
    Medium = 'medium-column',
    Large = 'large-column',
    ExtraLarge = 'extra-large'
}

export enum PaginatedDataActions {
    Add = 'add',
    Delete = 'delete',
    Review = 'review',
    Edit = 'edit',
    View = 'download',
    Postpone = 'postpone',
    Manage = 'manage',
    Preview = 'visibility'
}

export interface ActionConfig {
    [key: string]: BaseActionConfig;
}

export interface BaseActionConfig {
    disabled: boolean;
}
